import React from 'react';

interface NoDataPaymentIconProps {
  className?: string;
  size?: number;
}

const NoDataPaymentIcon: React.FC<NoDataPaymentIconProps> = ({ 
  className = "w-24 h-24 text-gray-300", 
  size = 24 
}) => {
  return (
    <div className={className}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-full h-full"
      >
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
        <circle cx="12" cy="9" r="2" />
        <path d="M12 11v4" />
      </svg>
    </div>
  );
};

export default NoDataPaymentIcon;
